module.exports = __webpack_public_path__ + "static/media/achievement-golden-socks.9c9a2bb6.svg";